<template>
  <div>
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>

    <v-card flat v-else>
      <v-row class="ma-2">
        <v-card-title class="primary--text"
          ><v-btn @click="back" class="ml-n7 primary--text" text>
            <v-icon>mdi-reply</v-icon></v-btn
          >Unload Cards
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Unload Funds From Card Users)</span
          >
        </v-card-title>

        <v-spacer></v-spacer>
        <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
          <v-chip class="mt-2" color="primary" outlined label>
            <span class="green--text subtitle-2">
              <b class="primary--text">Corporate Balance :</b>
              MYR {{ $store.getters.get_getCustDetails.funding_balance }}
            </span>
          </v-chip>
        </v-col>
      </v-row>
      <v-row class="mt-n4">
        <v-spacer />
        <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
          <v-text-field
            outlined
            v-model="search"
            color="primary"
            shaped
            dense
            class="mt-1 ml-3"
            label="Search "
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="1" xl="1" md="1" sm="12" xs="12">
          <v-btn
            small
            fab
            text
            @click="LoadFunds"
            color="dark"
            class="elevation-0 mt-1 ml-n3"
          >
            <v-icon dark>mdi-filter</v-icon>
          </v-btn></v-col
        >
      </v-row>
      <v-card class="ml-4 mr-4 mt-2 mb-3" flat>
        <v-row>
          <v-col cols="12">
            <v-card class="mt-n3">
              <v-spacer></v-spacer>

              <v-card-text flat>
                <v-data-table
                  :headers="headers"
                  :items="LoadFund"
                  dense
                  :no-data-text="noDataText"
                  class="overflow-hidden mt-n2"
                  :options.sync="pagination"
                  :items-per-page="itemsPerPage"
                  @update:options="LoadFundsPagination()"
                >
                  <template v-slot:[`item.sl_no`]="{ item }">
                    <span class="caption">{{
                      LoadFund.indexOf(item) + 1
                    }}</span>
                  </template>
                  <template v-slot:[`item.full_name`]="{ item }">
                    <span class="caption"
                      ><b>{{ item.full_name }}</b></span
                    >
                  </template>

                  <template v-slot:[`item.mobile_no`]="{ item }">
                    <span class="caption">{{ item.mobile_no }}</span>
                  </template>

                  <template v-slot:[`item.email_id`]="{ item }">
                    <span class="caption"> {{ item.email_id }}</span>
                  </template>

                  <template v-slot:[`item.department_name`]="{ item }">
                    <span class="caption"> {{ item.department_name }}</span>
                  </template>

                  <template v-slot:[`item.card_balance`]="{ item }">
                    <span class="caption"
                      ><b>{{ item.card_balance }}</b></span
                    >
                  </template>
                  <template v-slot:[`item.card_action`]="{ item }">
                    <v-btn
                      class="caption"
                      outlined
                      x-small
                      color="red"
                      @click="addbalance(item)"
                      >Unload</v-btn
                    >
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <UnloadCardDetails
        :secondcard="secondcard"
        :PropItem="PropItem"
        @click="CorpCardEmits"
      />
      <OverleyProccessg :overlay="overlay" />
    </v-card>
  </div>
</template>

<script>
import UnloadCardDetails from "@/components/Funds/UnloadCardDetails.vue";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
    UnloadCardDetails,
  },
  data: () => ({
    itemsPerPage: 15,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    secondcard: false,
    addbalancedialog: false,
    checkaccessdata: {},
    search: "",
    noDataText: "",
    name: "",
    overlay: false,
    spentdeprt: "",
    spentuser: "",
    Title: "",
    mblnumber: "",
    department: "",
    currentbalance: "",
    LoadFund: [],
    userid: "",
    departmentbudget: "",
    userbudget: "",
    PropItem: {},
    headers: [
      { text: "SL NO", value: "sl_no", sortable: false, align: "start" },

      {
        text: "USER NAME",
        value: "full_name",
        align: "start",

        sortable: false,
      },
      {
        text: "CONTACT NUMBER",
        value: "mobile_no",
        align: "start",

        sortable: false,
      },

      {
        text: "EMAIL",
        value: "email_id",
        align: "start",
        sortable: false,
      },
      {
        text: "DEPARTMENT",
        value: "department_name",
        align: "start",

        sortable: false,
      },
      {
        text: " CARD BALANCE (MYR)",
        value: "card_balance",
        align: "start",
        width: "10px",

        sortable: false,
      },
      {
        text: "ACTION",
        value: "card_action",
        align: "start",
        width: "10px",

        sortable: false,
      },
    ],
  }),
  created() {
    this.checkaccess();
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CARDFUNDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.LoadFunds();
        this.getuserdeatils();
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },

    CorpCardEmits() {
      this.secondcard = false;
    },

    addbalance(item) {
      // console.log("Keyyyy", key);
      // this.selectedRow = key;
      // console.log("selectedRow", this.selectedRow);
      // console.log("item", item);
      // this.loading=true
      this.secondcard = true;
      this.addbalancedialog = true;
      this.PropItem = item;
      // this.name = item.full_name;
      // this.mblnumber = item.mobile_no;
      // this.department = item.department_name;
      // this.departmentbudget = item.department_budget;
      // this.userbudget = item.user_budget;
      // this.currentbalance = item.card_balance;
      // this.userid = item.userid;
      // this.spentdeprt = item.department_spent;
      // this.spentuser = item.user_spent;
    },
    async LoadFundsPagination() {
      if (this.LoadFund.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        var inputData = {
          method_name: "CORPFUND",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "GETCARDUSERS",
            search_text: this.search,
            corp_id: this.$store.getters.get_corpid,
            type: 1,
          },
        };
        var responseData = await apiCall(inputData);

        this.LoadFund = this.LoadFund.concat(responseData.data.data);
      }
    },
    async LoadFunds() {
      this.overlay = true;
      var inputData = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCARDUSERS",
          search_text: this.search,
          corp_id: this.$store.getters.get_corpid,
          type: 1,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("inputData", inputData);
      // console.log("responseData", responseData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.LoadFund = responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
        this.overlay = false;

        this.getcountNotification();
        // console.log("REcords", this.LoadFund)
      } else {
        this.LoadFund = [];
        this.noDataText = responseData.data.status_msg;
        this.overlay = false;
      }
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: 2,
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log(responseData, "responseData");
      // if (responseData.data.data[0].module_code == "CARDFUNDS") {
      //   this.corpcount = responseData.data.data[0].count;
      //   this.$store.commit("SET_FundCount", this.corpcount);
      //   // console.log("corpcount", this.corpcount);
      // }
      for (let i = 0; i < responseData.data.data.length; i++) {
        switch (responseData.data.data[i].module_code) {
          case "CARDFUNDS":
            this.corpcount = responseData.data.data[i].count;
            this.$store.commit("SET_FundCount", this.corpcount);
            // console.log("custcount", this.custcount);
            break;
          case "EXMGMT1":
            this.expensecount1 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount1", this.expensecount1);
            //  console.log("corpcount", this.corpcount);
            break;
          case "EXMGMT2":
            this.expensecount2 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount2", this.expensecount2);
            //  console.log("corpcount", this.corpcount);
            break;
          case "EXRVRY":
            this.expenserecover = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseRecoverCount", this.expenserecover);
            break;
        }
      }
    },

    async getuserdeatils() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var rowlist = responseData.data.data;
          //console.log("getuserdeatils", rowlist.expense_approver_count);
          this.$store.commit("SET_Cusdetails", rowlist);
        }
        // rowlist.department_count = "1";
      }
    },
  },
};
</script>

<style>
.greencolor {
  color: red;
}
.bluecolor {
  color: green;
}
.bluecolor:hover {
  cursor: pointer;
}
.orangecolor {
  color: orange;
}
.orangecolor:hover {
  cursor: pointer;
}
.clr:hover {
  cursor: pointer;
}
.clr {
  color: darkturquoise;
}

.border {
  background-color: #eeeeee;
  margin-left: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.v-card.active:active {
  background: linear-gradient(
    90deg,
    rgba(165, 126, 60, 1) 0%,
    rgba(223, 192, 126, 1) 50%,
    rgba(165, 126, 60, 1) 100%
  );
  color: white;
  margin-left: 1px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.custom-highlight-row {
  background-color: #398bf7;
  /* rgb(158, 159, 243); */
}
.rowClass {
  cursor: pointer;
}
</style>
